module.exports = __webpack_public_path__ + "img/zakat.150fbcb6.svg";